import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State } from './types';
import { SERIES_REGISTRANTS_COLUMNS } from '../registrants/utils';

export const getInitialState = (): State => ({
  seriesRegistrants: [],
  isAllSelected: false,
  isSeriesRegistrantsLoading: false,
  orderBy: 'full_name',
  seriesRegistrantsSearchTerm: '',
  seriesRegistrantsCurrentPage: 1,
  seriesRegistrantsPerPage: 25,
  seriesRegistrantsCount: 0,
  uniqueColumnFilters: {},
  columnsFiltersSearchTerms: {},
  columns: SERIES_REGISTRANTS_COLUMNS,
  seriesSelectedRegistrants: {}
});

const state: State = getInitialState();

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
